import React, { useEffect, useState,useRef } from "react";
import BottomNav from "../components/BottomNav";
import Container from "../components/Container";
import Description from "../components/Description";
import FinancialHealthCheckup from "../components/FinancialHealthCheckup";
import Heading from "../components/Heading";
import Input from "../components/Input";
import PieGraph from "../components/PieGraph";
import ResultInput from "../components/ResultInput";
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Cell, ResponsiveContainer } from 'recharts';
import SelectMenu from "../components/SelectMenu";
import ASPieGraph from "../components/ASPieGraph";
import LineChart from "../components/LineChart";
import {useSelector,useDispatch} from 'react-redux'
import  { actions } from '../store/index'
import YourFHC from "../components/YourFHC";
import { Link } from "react-router-dom";

const KFormater = (num) => Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill="#0A1827" textAnchor="middle" dy={value < 0 ? 16 : -6} >{`${value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}</text>;
};

const AS = () => {

    const counter=useSelector((state)=>state.formdata)
    const dispatch=useDispatch()
    const hasCodeExecuted = useRef(false);


    const [selects, setselects] = useState();


    const [formData, setFormData] = useState({
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        T1: 0,
        T2: 0,
        T3: 0,
        T4: 0,
        H1: 0,
        H2: 0,
        H3: 0,
        H4: 0,
        H5: 0,
        H6: 0,
        H7: 0,
        H8: 0,
        H9: 0,
      
      

    }); // setting form data variables for input

    
    // states for storing names of Goal GL1, GL2 ...
    const [GoalGL1, setGoal1] = useState('')
    const [GoalGL2, setGoal2] = useState('')
    const [GoalGL3, setGoal3] = useState('')
    const [GoalGL4, setGoal4] = useState('')

    //an object for storing calculated variables from input data
    const [resultData, setResultData] = useState({
        R1: 0,
        R2: 0,
        R3: 0,
        R4: 0,
        R5: 0,
        R1a: 0,
        R2a: 0,
        R3a: 0,
        R4a: 0,
        R5a: 0,
        S2: 0
    });

    const [data,setData]=useState({
        T1New: 0,
        T3New: 0,
        LNew: 0,
        L: 0,
        L1: 0,
        GL1: 0,
        GL2: 0,
        GL3: 0,
        GL4: 0,

    })

    data.LNew= data.L
    

    const [Slack, setSlack] = useState(0);// declaring state for slack
    const [Networth, setNetworth] = useState(0); // declaring state for networth

    // Handling changes in Goal selections such as travel, education....
    const goalChangeHandler = (e) => {

        if (e.target.id === 'GoalGL1') {
            setGoal1(e.target.value)
        }
        else if (e.target.id === 'GoalGL2') {
            setGoal2(e.target.value)
        }
        else if (e.target.id === 'GoalGL3') {
            setGoal3(e.target.value)
        }
        else {
            setGoal4(e.target.value)
        }

    };

    //handling changes in inout variables and updating them
    const changeHandler = (e) => {

        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });

     

    };

    const dataChangeHandler = (e) => {

        setData({
            ...data,
            [e.target.id]: e.target.value
        });

     

    };

   // setting input fields for goals GL! and GL2
    const [inputFields, setInputFields] = useState([
        {
            label: <div>
                <label className="peer-focus:text-primary  text-chinese-black/70  xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm">Financial Goal 1 (Select)</label>

                <select id="GoalGL1" className="bg-bright-gray/50  text-gray-900 text-sm  py-3 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  focus:outline-primary outline-primary" onChange={goalChangeHandler}>
                    <option selected className='peer-focus:text-primary text-chinese-black/70 hidden xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm text-black '>Select</option>
                    <option value="Education" className='text-black' >Education</option>
                    <option value="Travel" className='text-black'>Travel</option>
                    <option value="Investment" className='text-black'>Investment</option>
                    <option value="Other" className='text-black'>Other</option>
                </select>
            </div>,
            flag: true
        },
        {
            label: 'Financial Goal 1 Amount',
            flag: false,
            id: 'GL1',
            val: data.GL1
        },
        {
            label: 'Financial Goal 1 time (years)',
            flag: false
        },
        {
            label: <div>
                <label className="peer-focus:text-primary  text-chinese-black/70  xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm">Financial Goal 2 (Select)</label>

                <select id="GoalGL2" className="bg-bright-gray/50  text-gray-900 text-sm  py-3 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  focus:outline-primary outline-primary" onChange={goalChangeHandler}>
                    <option selected className='peer-focus:text-primary text-chinese-black/70 hidden xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm text-black '>Select</option>
                    <option value="Education" className='text-black' >Education</option>
                    <option value="Travel" className='text-black'>Travel</option>
                    <option value="Investment" className='text-black'>Investment</option>
                    <option value="Other" className='text-black'>Other</option>
                </select>
            </div>,
            flag: true
        },
        {
            label: 'Financial Goal 2 Amount',
            flag: false,
            id: 'GL2',
            val: data.GL2

        },
        {
            label: 'Financial Goal 2 time (years)',
            flag: false
        },
    ]);

    //handling dynamic additions of Goal GL3 and GL4 on add goal click button
    const handleAddFields = () => {
        const values = [...inputFields];

        if (data.GL4 != '') {

        }
        else if (data.GL2 != '' && data.GL1 != '') {
            if (data.GL3 != '' && !inputFields.find(ida => ida.id === 'GL4')) {

                const len = 4
              
                values.push({
                    label: <div>
                        <label className="peer-focus:text-primary  text-chinese-black/70  xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm">Financial Goal 4 (Select)</label>

                        <select id="GoalGL4" className="bg-bright-gray/50  text-gray-900 text-sm  py-3 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  focus:outline-primary outline-primary" onChange={goalChangeHandler}>
                            <option selected className='peer-focus:text-primary text-chinese-black/70 hidden xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm text-black '>Select</option>
                            <option value="Education" className='text-black' >Education</option>
                            <option value="Travel" className='text-black'>Travel</option>
                            <option value="Investment" className='text-black'>Investment</option>
                            <option value="Other" className='text-black'>Other</option>
                        </select>
                    </div>,
                    flag: true
                },
                    {
                        label: `Financial Goal ${len} Amount`,
                        flag: false,
                        id: `GL${len}`,
                        val: data.GL4
                    },
                    {
                        label: `Financial Goal ${len} time (years)`,
                        flag: false
                    },
                )
            }
            else if (!inputFields.find(ida => ida.id === 'GL3')) {
                const len = 3
                
                values.push({
                    label: <div>
                        <label className="peer-focus:text-primary  text-chinese-black/70  xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm">Financial Goal 3 (Select)</label>

                        <select id="GoalGL3" className="bg-bright-gray/50  text-gray-900 text-sm  py-3 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700  focus:outline-primary outline-primary" onChange={goalChangeHandler}>
                            <option selected className='peer-focus:text-primary text-chinese-black/70 hidden xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm text-black '>Select</option>
                            <option value="Education" className='text-black' >Education</option>
                            <option value="Travel" className='text-black'>Travel</option>
                            <option value="Investment" className='text-black'>Investment</option>
                            <option value="Other" className='text-black'>Other</option>
                        </select>
                    </div>,
                    flag: true
                },
                    {
                        label: `Financial Goal ${len} Amount`,
                        flag: false,
                        id: `GL${len}`,
                        val: data.GL3
                    },
                    {
                        label: `Financial Goal ${len} time (years)`,
                        flag: false
                    },
                )
            }
        }
    

        setInputFields(values);
    };


    const update=()=>
    {
        Object.keys(counter).length>0?
        setFormData(counter):
        setFormData(formData)
    }

    useEffect(() => {

        if (!hasCodeExecuted.current) {

            update()
            hasCodeExecuted.current = true;

            window.scrollTo(0, 0);
        }

        const { M1, M2, M3, M4, T1, T2, T3, T4} = formData;  // getting input variables from form data
        const {GL1, GL2 }=data
        setResultData({
            R1: (Number(M3) / Number(M1)) * 100,
            R2: Number(T1) / (Number(M2) + Number(M3) + Number(M4)) * 100,
            R3: ((Number(T1) + Number(T2)) / (Number(T3) + Number(T4))) * 100,
            R4: (Number(T1) / (Number(M3) + Number(M4))) * 100,
            R5: (Number(M4) / Number(M1)) * 100
        });//performing calculations and setting result variables

        setCartData([{
            name: 'Total Savings',
            value: Number(T1),
            color: "green"
        },
        {
            name: 'Investments',
            value: Number(T2),
            color: "green"
        },
        {
            name: 'Total Debt',
            value: -Number(T3),
            color: "red"
        },
        {
            name: 'Mortgage',
            value: -Number(T4),
            color: "pink"
        }]); // updating graph data

        
        data.T1New = T1
        data.T3New = T3
        dispatch(actions.updateFormData(formData))

        setSlack(Number(M1) - (Number(M2) + Number(M3) + Number(M4))); // setting Slack 1 after computing
        setNetworth((Number(T1) + Number(T2)) - Number(T3)); // setting Networth 
    }, [formData, Slack, GoalGL1, GoalGL2,data]);

    const [chartData, setCartData] = useState([{
        name: 'Total Savings',
        value: Number(formData.T1),
        color: "green"
    },
    {
        name: 'Investments',
        value: Number(formData.T2),
        color: "green"
    },
    {
        name: 'Total Debt',
        value: -Number(formData.T3),
        color: "red"
    },
    {
        name: 'Mortgage',
        value: -Number(formData.T4),
        color: "pink"
    }]); // declaring chart data
 
    // for dynamic addition of statments to show in recommendation section
    let goalStats = ''

    //function for calculating goal allotments
    function TenureAllotment(Ln) {
        let values = [
            { 'name': GoalGL1, amount: data.GL1 },
            { 'name': GoalGL2, amount: data.GL2 },
            { 'name': GoalGL3, amount: data.GL3 },
            { 'name': GoalGL4, amount: data.GL4 },
        ]

        values = values.filter(value => value.amount > 0).sort((a, b) => a.amount - b.amount); //sorting values in ascending order who are greater than 0

    
        values.map((val) => {
            if (val.amount > 0) {
                if (Number(Ln) - Number(val.amount) >= 0) {
                    Ln = Number(Ln) - Number(val.amount)
                    console.log('T3', Ln)
                    goalStats += `Allocate Lumpsum amount to achieve your Goal ${val.name}. `
                }
                else {
                    if (Ln > 0) {

                        Ln = 0
                        goalStats += `Allocate Lumpsum towards a portion of your Goal ${val.name}`
                    }
                }
            }
        })

      
        return Ln
    }


    return (
        <div className="w-full ">
            <div className="bg-gradient-to-b h-72 from-primary to-patric-blue">
                <Container classes={"flex flex-col p-4 px-5 space-y-6 md:space-y-0  md:py-10 md:flex-row items-center w-full justify-between"}>
                    <div className="w-full md:w-auto">
                        <Link to={'/'}>
                        <img src="./assets/images/logo-white.png" alt="logo" />
                        </Link>
                        
                        </div>
                    <h1 className="text-white font-bold text-center text-2xl md:text-4xl">Allocate Savings</h1>
                    <div className="hidden md:block"></div>
                </Container>

                <div className="text-white  text-center mb:mx-0 mx-5 md:ml-40 -mt-3 md:-mt-7 text-lg md:text-2xl">You've got money! Find the best way to deploy it </div>

            </div>
            <Container classes={"-mt-24 md:-mt-32 py-10 space-y-6"}>
             
                <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                        <div className="shadow-md p-6 bg-white space-y-6">
                            <Heading text={"Basic Financial Inputs "} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"M1"} value={formData.M1} label={"Monthly Income"} onChange={changeHandler} />
                                <Input type={"number"} id={"T1"} value={formData.T1} label={"Total Savings (Liquid Funds)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M2"} value={formData.M2} label={"Monthly Expenses"} onChange={changeHandler} />
                                <Input type={"number"} id={"T2"} value={formData.T2} label={"Stocks, bonds, real estate etc."} onChange={changeHandler} />
                                <Input type={"number"} id={"M3"} value={formData.M3} label={"Monthly Debt pmt (credit card, car etc)"} onChange={changeHandler} />
                                <Input type={"number"} id={"T3"} value={formData.T3} label={"Total Debt (except mortgage)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M4"} value={formData.M4} label={"Housing / Rent, Tax, Inurance"} onChange={changeHandler} />
                                <Input type={"number"} id={"T4"} value={formData.T4} label={"Mortgage Balance"} disable onChange={changeHandler} />
                            </div>


                        </div>


                     
              <YourFHC R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Slack={Slack}/>


                    </div>

                </div>



              

                <div className="flex-1 w-full md:flex-none space-y-6">
                    <div className="shadow-md p-6 bg-white space-y-12">
                        <div className="hidden md:block">

                            <Heading text={"Savings Details"} icon={"financial-input"} />
                        </div>
                        <div className="block md:hidden md:px-0 md:text-center">

                            <Heading text={"Savings Details"} classes={' '} />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-28 md:ml-7  md:px-0">

                            <Input type={"number"} id={"L"} value={data.L} label={"Lump Sum Amount"} onChange={dataChangeHandler} />
                      

                            <Input type={"number"} id={"L1"} value={data.L1} label={"APR for debts"} onChange={dataChangeHandler} />
                          
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 gap-4 md:gap-y-8 lg:gap-x-28 md:ml-7  md:px-0">
                            {inputFields.map((inputField, index) => (
                                <div key={index}>
                                   
                                    {inputField.flag === true ? inputField.label :

                                        <Input type='number' id={inputField.id} label={inputField.label} onChange={dataChangeHandler} />}

                                </div>
                            ))}
                            <div className="relative h-[72px]">



                                <button className="w-full peer border-2 absolute bottom-0 bg-bright-gray/50  rounded-xl py-3 px-4 outline-primary outline-primary peer-focus:text-primary text-chinese-black/70   font-medium text-[10px] sm:text-xs md:text-sm text-primary font-bold" onClick={() => handleAddFields()}>
                                    <div className="flex justify-between">
                                        <p className="peer-focus:text-primary text-chinese-black/70   font-medium text-[10px] sm:text-xs md:text-sm text-primary font-bold">Add more Goals</p>
                                        <div className="border-2 rounded-md px-2">
                                            <p className=" peer-focus:text-primary text-chinese-black/70   font-medium text-[10px] sm:text-xs md:text-sm text-primary font-bold shadow-primary">+</p>
                                        </div>
                                    </div>
                                </button>

                            </div>


                        </div>


                    </div>
                </div>






                <div className="block md:flex   px-5">

                    <div className="hidden md:block w-7/12">
                        <PieGraph heading="Current Cash Flow Distribution" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                    </div>
                    <div className="md:hidden">
                        <PieGraph heading="Current Cash Flow Distribution" subheading="" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                    </div>
                    <div className="md:pl-14 mt-10 md:mt-24">
                        <Description R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Networth={Networth} />
                    </div>




                </div>










                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20 ">

                    {isNaN(data.L1) ? '' :
                        data.L1 > 5 ?
                            <div className="w-full md:flex-1  shadow-md  p-8 ">
                                <div className="px-0 md:px-20">
                                    <Heading text="High Debt or Interest rate (APR)" classes={"text-center"} />
                                </div>
                                <div className="flex justify-center pt-5 pb-2 ">
                                    <div className="md:w-1/2 md:px-0 px-10 space-y-2">
                                        <p className="text-center font-bold">You have high APR debt. Consider paying off your debt.</p>
                                        {Number(data.L) >= Number(formData.T3) && formData.T3 > 0 && data.L > 0 ?
                                            <div className="text-center font-bold">

                                                <p >You can pay off your entire Debt.</p>
                                                <p className="hidden"> {data.T3New = 0} {data.LNew= Number(data.L) - Number(formData.T3)} </p>

                                            </div>
                                            :
                                            formData.T3 > 0 && data.L > 0 ?
                                                <div className="text-center font-bold">
                                                    <p> You can pay off a portion ${data.L} of your Debt. </p>
                                                    {Slack > 0 ? <p className="text-center font-bold">You have ${Slack} surplus in your budget every month, you can use this to first pay off your remaining debt and then start saving for your financial goals</p> : ''}
                                                    <p className="hidden">{data.T3New = Number(formData.T3) - Number(data.L)} {data.LNew= 0} </p>


                                                </div> : ''

                                        }
                                       
                                    </div>
                                </div>

                            </div>
                            : ''}

                    {(Number(data.L)) > 0 && (Number(resultData.R2)).toFixed(0) < 300 && (Number(resultData.R2)).toFixed(0) > 0 ?
                        <div className="w-full md:flex-1  shadow-md  p-8 ">
                            <div className="px-0 md:px-20">
                                <Heading text="Emergency Fund Coverage" classes={"text-center"} />
                            </div>
                            <div className="flex justify-center pt-5 pb-5 ">
                                <div className="md:w-1/2 md:px-0 px-10 space-y-2">
                                    <p className="text-center font-bold">You should allocate Lumpsum amount to boost your Emergency Fund. </p>
                                    {(Number(formData.T1) + Number(data.LNew)) > (3 * (Number(formData.M2) + Number(formData.M3) + Number(formData.M4))) ?
                                        <div className="text-center font-bold">
                                            <p>Add a portion of remaining Lumpsum amount to your Savings ${formData.T1} to bring Expense Coverage Ratio R2 to 300%. </p>
                                            <p className="hidden">{data.LNew= Number(data.L) - (3 * (Number(formData.M2) + Number(formData.M3) + Number(formData.M4)))} {data.T1New = (3 * (Number(formData.M2) + Number(formData.M3) + Number(formData.M4)))} </p>
                                        </div>
                                        :
                                        <div className="text-center font-bold">
                                            <p> Boost Savings ${formData.T1} by remaining Lumpsum Amount ${data.LNew}.  </p>
                                            {Slack > 0 ? <p className="text-center font-bold">You have {Slack} surplus in your budget every month, you can use this to boost your Emergency Fund to at least 300% of expenses and then start using your monthly Slack towards your financial goals</p> : ''}

                                            <p className="hidden">{data.LNew= 0}</p>
                                        </div>
                                    }

                                 
                                </div>
                            </div>

                        </div> : ''}


              
                    {isNaN(data.LNew) ? '' :
                        data.LNew> 0 && (data.GL1 > 0 || data.GL2 > 0) ?
                            <div className="w-full md:flex-1  shadow-md  p-8 ">
                                <div className="px-0 md:px-20">
                                    <Heading text="Financial goal allotment" classes={"text-center"} />
                                </div>
                                <div className="flex justify-center pt-5 pb-5 ">
                                    <div className="md:w-10/12 md:px-0 px-10 space-y-2">
                                        <p className="hidden">
                                            {data.LNew= TenureAllotment(data.LNew)}
                                        </p>
                                        <p className="text-center font-bold px-5">{goalStats}</p>
                                     

                                    </div>
                                </div>

                            </div>
                            :
                            null}


                    {isNaN(data.LNew) ? '' :
                        data.LNew> 0 ?
                            <div className="w-full md:flex-1  shadow-md  p-8 ">
                                <div className="px-0 md:px-20">
                                    <Heading text="Remaining Lumpsum Utilization " classes={"text-center"} />
                                </div>
                                <div className="flex justify-center pt-5 pb-5 ">
                                    <div className="md:w-1/2 md:px-0 px-10 space-y-2">
                                        <p className="text-center font-bold">You have savings left after paying off debt, emergency fund and allocating to your goals.</p>
                                        <p className="text-center font-bold">Consider increasing your emergency fund to Greater than 3 months.</p>
                                        <p className="text-center font-bold">
                                            Consider investing the rest of your Lumpsum {data.LNew} for your future.</p>
                                        <p className="text-center font-bold">
                                            Consider the rest of your Lumpsum {data.LNew} to buy something nice for yourself or your loved ones.

                                        </p>
                                    </div>
                                </div>

                            </div>
                            :
                            null
                    }


                </div>



                {resultData.R2 > 300 ?

                    <div className="md:flex justify-between md:space-x-24 pt-10">
                        <div className="w-full md:flex-1 p-5  shadow-md   ">
                            <div className="px-0 md:px-20">

                                <Heading text="Financial Measures(post - 
allocation)" classes={"items-center px-10 md:px-10"} />
                            </div>
                            <div className="flex justify-center">


                            </div>
                            <div className="flex justify-center p-5">
                                <div className="hidden">
                                    {resultData.R1a = (Number(formData.M3) / Number(formData.M1)) * 100}
                                    {resultData.R2a = (Number(data.T1New) / (Number(formData.M2) + Number(formData.M3) + Number(formData.M4))) * 100}
                                    {resultData.R3a = ((Number(data.T1New) + Number(formData.T2)) / (Number(data.T3New) + Number(formData.T4))) * 100}
                                    {resultData.R4a = ((Number(data.T1New) / (Number(formData.M3) + Number(formData.M4)))) * 100}
                                    {resultData.R5a = (Number(formData.M4) / Number(formData.M1))}
                                    {resultData.S2 = Number(formData.M1) - (Number(formData.M2) + Number(formData.M3) + Number(formData.M4))}
                                </div>
                                <div className=" md:w-1/2 md:px-0 px-10 space-y-7">
                                    <ResultInput label={'Debt / Income ratio'} value={isNaN(resultData.R1a) || resultData.R1a === Infinity ? 0 : resultData.R1a.toFixed(2) + '%'} tooltip={"How much of your income is spent on Debt Payments? Recommended < 20%"}/>
                                    <ResultInput label={'Expense coverage ratio by savings'} value={isNaN(resultData.R2a) || resultData.R2a === Infinity ? 0 : resultData.R2a.toFixed(2) + '%'}  tooltip={"How many times does your savings cover monthly expenses(expenses, debt and rent)? Recommended>300% (3 months)"}/>
                                    <ResultInput label={'Assets / Liabilities'} value={isNaN(resultData.R3a) || resultData.R3a === Infinity ? 0 : resultData.R3a.toFixed(2) + '%'} tooltip={"Ratio of what you have vs what you owe. Recommended>100% (positive net worth)"} />
                                    <ResultInput label={'Assets / (Rent + Debt) coverage'} value={isNaN(resultData.R4a) || resultData.R4a === Infinity ? 0 : resultData.R4a.toFixed(2) + '%'} tooltip={"How many times can your obligations be covered by assets? Recommended > 1200% (one year) "} />
                                    <ResultInput label={'Housing cost ratio'} value={isNaN(resultData.R5) || resultData.R5 === Infinity ? 0 : resultData.R5.toFixed(2) + '%'} tooltip={"How much of your income is spent on housing costs? Recommended < 30% "}/>
                                    <ResultInput label={'Slack in Budget'} value={isNaN(resultData.S2) || resultData.S2 === Infinity ? 0 :  resultData.S2.toFixed(0)} isLast  tooltip={"This is the surplus each month which can be used for goal planning"}/>


                                </div>

                            </div>
                        </div>

                        <div className=" w-full w-9/12 md:w-1/2 pt-5 md:block  justify-center px-0 md:px-0 ">
                            <ASPieGraph heading="Allocation of Lump Sum amount" L={data.L} L1={data.L1} M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} T1={formData.T1} T3={formData.T3}
                                GL1={data.GL1} GL2={data.GL2} GL3={inputFields.find(ida => ida.id === 'GL3') ? data.GL3 : 'X'} GL4={inputFields.find(ida => ida.id === 'GL4') ? data.GL4 : 'X'} R2={resultData.R2}
                            />
                        </div>

                    </div>

                    : ''}



                <div className="pt-10">
                    <BottomNav />
                </div>

            </Container>
        </div>
    );
};

export default AS;